/**
 * Detects if the device is mobile based on the user-agent string
 * @param userAgent - The user-agent string from the request headers
 * @returns boolean indicating if the device is mobile
 */
export const isMobileDevice = (userAgent: string = ''): boolean => {
  return /mobi|android|iphone|ipad|ipod/i.test(userAgent);
};
